module.exports = __webpack_public_path__ + "img/罗显刚.39f0193f.jpg";